module.exports = __webpack_public_path__ + "static/media/SearchIcon.0b9941f4.svg";